export default {
  common: {
    clearAll: 'Esborra-ho tot',
    restart: 'Reinicia'
  },
  download: {
    bodyText: "Fes clic en l'enllaç següent per descarregar %{products}",
    bothProducts: 'PlayBase i/o Nexus',
    bodyTextFromAcceptInvitation:
      'El procés portarà algun temps. Mentrestant, pots continuar utilitzant Metrica Sports com de costum.',
    bodyTextFromDeclineInvitation:
      "Has rebutjat la invitació! Fes clic en l'enllaç de sota per descarregar %{products}",
    bodyTextFromTrial:
      'Benvingut al teu període de prova! Comprova el teu correu electrònic per obtenir un enllaç de verificació (mira la carpeta de correu no desitjat).',
    bodyTitle: 'Descarregar',
    bodyTitleFromAcceptInvitation: 'Estem canviant el teu compte',
    bodyTitleFromDeclineInvitation: 'Invitació Rebutjada',
    bodyTitleFromTrial: 'Inscripció completada',
    play2: {
      description:
        "Metrica PlayBase és una eina d'anàlisi intuïtiva dissenyada per a entrenadors aficionats i prosumidors, petits clubs i analistes independents. Simplifica el procés d'avaluació del rendiment, fent-lo accessible per a tothom.",
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        "Metrica Nexus està dissenyat per a analistes i entrenadors d'elit que busquen informació exhaustiva sobre el rendiment. Amb eines avançades al teu abast, pots millorar les estratègies de l'equip i assolir l'èxit.",
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Gràcies per registrar-te a Metrica Sports! Per començar amb la teva prova, descarrega %{products}.'
  },
  error: {
    restart: 'Sembla que estàs intentant entrar en alguna cosa que encara estem desenvolupant...',
    tryAgainMsg:
      "Si us plau, torna-ho a provar. Si aquest error continua, contacta amb l'equip de suport de Metrica Sports"
  },
  verifyEmail: {
    generateLink: 'Genera un enllaç nou iniciant sessió a Play',
    readyToLogin: 'Ja esteu preparat per iniciar sessió a Play',
    successfully: 'Correu electrònic verificat correctament',
    unsuccessfully: 'Error en verificar el correu electrònic, token no vàlid'
  }
}
